// Accounting Expenses Types Vuex

import state from './expenseTypeStates.js'
import * as getters from './expenseTypeGetters.js'
import * as mutations from './expenseTypeMutations.js'
import * as actions from './expenseTypeActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
